import { defaultTheme as Flex } from './Flex/theme';

const defaultTheme = {
  ...Flex,
};

export { defaultTheme };
